/* global axios */

import ApiClient from './ApiClient';

class ChannelWebHooks extends ApiClient {
  constructor() {
    super('webhooks_inbox');
  }

  getByInboxID(id) {
    return axios.get(`${this.url}?inbox_id=${id}`);
  }
}

export default new ChannelWebHooks();
